import React, { useEffect, useState } from 'react';
import { useTokens } from '../hooks/useTokens';
import { useNavigate } from 'react-router-dom';

export default function TokenCounter() {
  const { balance, loading, subscriptionTier } = useTokens();
  const navigate = useNavigate();
  const [displayBalance, setDisplayBalance] = useState(balance);
  const [showTooltip, setShowTooltip] = useState(false);

  const planLabel: Record<string, string> = {
    free: 'Free',
    pro: 'Pro',
    business: 'Business',
    enterprise: 'Enterprise',
  };

  useEffect(() => {
    if (balance !== displayBalance && !loading) {
      const diff = displayBalance - balance;
      const steps = 20;
      const stepValue = diff / steps;
      let currentStep = 0;
      const interval = setInterval(() => {
        currentStep++;
        setDisplayBalance(prev => Math.max(balance, prev - stepValue));
        if (currentStep >= steps) {
          clearInterval(interval);
          setDisplayBalance(balance);
        }
      }, 30);
      return () => clearInterval(interval);
    }
  }, [balance]);

  const formatTokens = (tokens: number): string => {
    if (tokens >= 1000000) return `${(tokens / 1000000).toFixed(1)}M`;
    if (tokens >= 1000) return `${(tokens / 1000).toFixed(1)}K`;
    return tokens.toLocaleString('fr-FR');
  };

  if (loading) return null;

  return (
    <>
      <button
        onClick={() => navigate('/billing')}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="flex items-center gap-2 px-2 py-1.5 text-[12px] hover:bg-theme-hover"
        title="Gérer l'abonnement"
      >
        <span className="page-kicker !text-[9px] !tracking-[0.16em]">
          {planLabel[subscriptionTier || 'free'] || 'Free'}
        </span>
        <span className="font-mono tabular-nums text-theme-primary">
          {formatTokens(Math.floor(displayBalance))}
        </span>
      </button>

      {showTooltip && (
        <div
          className="fixed px-3 py-2 bg-theme-surface border border-theme text-theme-primary text-xs whitespace-nowrap"
          style={{ top: '56px', right: '20px', zIndex: 999999 }}
        >
          {balance.toLocaleString('fr-FR')} tokens
        </div>
      )}
    </>
  );
}
